// src/Component/PackageForm.js
import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import './PackageDetails.css';

const PackageForm = ({ packageData, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    detail: '',
    year: 1,
    price: 0
  });

  useEffect(() => {
    if (packageData) {
      setFormData({
        detail: packageData.detail,
        year: packageData.year,
        price: packageData.price
      });
    }
  }, [packageData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'year' || name === 'price' ? Number(value) : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="package-form-overlay">
      <div className="package-form">
        <div className="form-header">
          <h3>{packageData ? 'Edit Package' : 'Add New Package'}</h3>
          <button onClick={onCancel} className="close-btn">
            <FiX />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Package Name</label>
            <input
              type="text"
              name="detail"
              value={formData.detail}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Years</label>
            <input
              type="number"
              name="year"
              min="0"
              value={formData.year}
              onChange={handleChange}
              placeholder="Enter years (e.g. 0, 1, 2)"
              required
            />
          </div>
          <div className="form-group">
            <label>Price (₹)</label>
            <input
              type="number"
              name="price"
              min="0"
              step="1"
              value={formData.price}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-actions">
            <button type="button" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit">
              {packageData ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PackageForm;